import { getGnbList } from '@/common/util/menu.util'
import { hasUserConfirmPPV } from '@/common/util/common'

const state = {
  beforeMyPooqPath: '',
  beforeEnterPlayerPath: ''
}

const getters = {
  mainMenuItems () {
    if (hasUserConfirmPPV()) {
      return getGnbList().filter((menu) => {
        return menu.uicode !== 'GN4'
      })
    } else {
      return getGnbList().filter((menu) => {
        return menu.uicode !== 'GN16'
      })
    }
  },
  getBeforePathOpenMyPooq () {
    return state.beforeMyPooqPath
  },
  getBeforeEnterPlayerPath () {
    return state.beforeEnterPlayerPath
  }

}
const mutations = {
  setBeforePathOpenMyPooq (state, path) {
    state.beforeMyPooqPath = path
  },
  setBeforeEnterPlayerPath (state, path) {
    state.beforeEnterPlayerPath = path
  }
}

export default { state, getters, mutations }
